export const SERVER_IP = '';
export const httpOption = {
  // timeout: 5000,
  cache: false,
  xhrFields: {
    withCredentials: true,
  },
};
